// HM-304 demo: SortableList wrapper @dnd-kit applicato a una lista
// esempio di prodotti menu. Routata in HM-307 a /dev/dnd.

import { SortableList } from '@hotel-manager/ui/dnd';
import { useState } from 'react';

interface MenuItem {
  id: string;
  name: string;
  price: string;
  category: string;
}

const initial: MenuItem[] = [
  { id: 'p1', name: 'Spritz Aperol', price: '€ 6,00', category: 'Bevande' },
  { id: 'p2', name: 'Tagliere salumi misti', price: '€ 14,00', category: 'Antipasti' },
  { id: 'p3', name: 'Pasta al pomodoro', price: '€ 9,00', category: 'Primi' },
  { id: 'p4', name: 'Tiramisu della casa', price: '€ 6,50', category: 'Dolci' },
  { id: 'p5', name: 'Caffe espresso', price: '€ 1,50', category: 'Bevande' },
];

export function DndDemo() {
  const [items, setItems] = useState<MenuItem[]>(initial);

  return (
    <div className="min-h-screen bg-bg-base p-8 text-text-primary">
      <h1 className="text-3xl font-bold mb-2">Drag & Drop — @dnd-kit</h1>
      <p className="text-text-secondary mb-8">
        SPEC v2.6: libreria UNICA per i 4 punti drag&drop. Wrapper SortableList per riordino
        verticale, raw API per use-case complessi (Gantt, kanban, visual builder KNX).
      </p>

      <div className="bg-bg-card rounded-lg shadow-hm-md p-6 max-w-2xl">
        <div className="text-sm text-text-secondary mb-4">
          Trascina una riga per riordinare il menu. Ordine corrente:
          <span className="ml-2 font-mono text-xs text-text-muted">
            {items.map((i) => i.id).join(' > ')}
          </span>
        </div>

        <SortableList
          items={items}
          onReorder={setItems}
          className="space-y-2"
          renderItem={(item, isDragging) => (
            <div
              className={`bg-bg-base border border-border-base rounded-md p-4 cursor-grab active:cursor-grabbing flex items-center justify-between ${
                isDragging ? 'shadow-hm-lg ring-2 ring-accent-primary' : 'shadow-hm-sm'
              }`}
            >
              <div>
                <div className="font-semibold">{item.name}</div>
                <div className="text-xs text-text-muted">{item.category}</div>
              </div>
              <div className="text-accent-primary-text font-mono">{item.price}</div>
            </div>
          )}
        />
      </div>
    </div>
  );
}
